import { render, staticRenderFns } from "./autoHeight.vue?vue&type=template&id=123b7c4f"
import script from "./autoHeight.vue?vue&type=script&lang=js"
export * from "./autoHeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports